import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "@apollo/client";
import { Link } from "react-router-dom";
import UserProfile from "./UserProfile";
import LanguageSwitcher from "./LanguageSwitcher";
import SalponLogo from "./SalponLogo";
import { IS_ADMIN } from "./Event/useEventHooks";
import styles from "./Navigation.module.css";

const Navigation: React.FC = () => {
  const { t } = useTranslation();
  const { data } = useQuery(IS_ADMIN);
  const isAdmin = data?.isAdmin === true;
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className={styles.topBar}>
      <div className={styles.left}>
        <Link className={styles.logo} to="/events">
          <SalponLogo size={24} className={styles.logoIcon} /><span>Salp<span className={styles.logoAccent}>ö</span>n</span>
        </Link>
        <Link className={`${styles.navLink} ${styles.desktopOnly}`} to="/events">
          {t("nav.events")}
        </Link>
        {isAdmin && (
          <Link className={`${styles.navLink} ${styles.desktopOnly}`} to="/admin">
            {t("nav.admin")}
          </Link>
        )}
      </div>

      <div className={styles.right}>
        <div className={styles.desktopOnly}>
          <LanguageSwitcher />
        </div>
        <div className={styles.desktopOnly}>
          <UserProfile />
        </div>

        <button
          className={styles.burger}
          type="button"
          onClick={() => setMenuOpen((o) => !o)}
          aria-label="Menu"
        >
          <span className={`${styles.burgerLine} ${menuOpen ? styles.burgerOpen1 : ""}`} />
          <span className={`${styles.burgerLine} ${menuOpen ? styles.burgerOpen2 : ""}`} />
          <span className={`${styles.burgerLine} ${menuOpen ? styles.burgerOpen3 : ""}`} />
        </button>
      </div>

      {menuOpen && (
        <div className={styles.mobileMenu}>
          <Link className={styles.mobileLink} to="/events" onClick={() => setMenuOpen(false)}>
            {t("nav.events")}
          </Link>
          {isAdmin && (
            <Link className={styles.mobileLink} to="/admin" onClick={() => setMenuOpen(false)}>
              {t("nav.admin")}
            </Link>
          )}
          <div className={styles.mobileDivider} />
          <div className={styles.mobileRow}>
            <LanguageSwitcher />
          </div>
          <div className={styles.mobileRow}>
            <UserProfile />
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
